import { formatBoolean, formatBooleanToYesNo } from 'components/helper/helper';
import CheckboxInput from 'components/input/CheckboxInput';
import { SemesterOption } from 'screen/counselor/components/CoursesAndGrades/CoursesAndGradesOptions';

interface Props {
  data: any[];
}

const CourseGrade9Summary = ({ data }: Props) => {
  const _getGrade = (subject:any, index:number) => {
    if (subject.grade && subject.grade.length>0) {
      if (index>=0 && index<subject.grade.length) {
        return subject.grade[index] ?? '';
      }
    }
    return '';
  }
  const _getCredit = (subject:any, index:number) => {
    if (subject.credits && subject.credits.length>0) {
      if (index>=0 && index<subject.credits.length) {
        return Number(subject.credits[index] ?? 0) 
      }
    }
    return 0;
  }
  const _countGrades = (course:any) => {
    switch (course?.schedule) {
      case 'Semester':
        return 2;
      case 'Trimester':
        return 3;
      case 'Quarter':
      case 'Quarters':
        return 4;
      default:
        return 0;
    }
  }
  return (
    <>
      {(data ?? []).map((item: any, index: number) => {
        let semesterOption:any = [];
        switch (item.schedule) {
          case 'Semester':
            semesterOption = [
              { value: 'isFirstSemester', label: 'First Semester', fieldIndex: 0 },
              { value: 'isSecondSemester', label: 'Second Semester', fieldIndex: 1 },
            ];
            break;
          case 'Trimester':
            semesterOption = [
              { value: 'isFirstSemester', label: 'First Trimester', fieldIndex: 0 },
              { value: 'isSecondSemester', label: 'Second Trimester', fieldIndex: 1 },
              { value: 'isThirdSemester', label: 'Third Trimester', fieldIndex: 2 },
            ];
            break;
          case 'Quarters':
            semesterOption = [
              { value: 'isFirstSemester', label: 'First Quarter', fieldIndex: 0 },
              { value: 'isSecondSemester', label: 'Second Quarter', fieldIndex: 1 },
              { value: 'isThirdSemester', label: 'Third Quarter', fieldIndex: 2 },
              { value: 'isFourthSemester', label: 'Fourth Quarter', fieldIndex: 3 },
            ];
            break;
          default:
            semesterOption = [];
        }

        return (
          <div key={index} className="gm-summary-conditional-section">
            <div className="gm-summary-conditional-title">
              School Information
            </div>
            
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-field-label">Select the school for this coursework</div>
                <div className="gm-summary-field-value">
                  {item?.schoolName || '-'}
                </div>
              </div>
            </div>

            <div className="row w-100">
              <div className="col-md-6 pe-md-2">
                <div className="gm-summary-field-label">School Year*</div>
                <div className="gm-summary-field-input">{item?.schoolYear || '-'}</div>
              </div>
              <div className="col-md-6 ps-md-2">
                  <div className="gm-summary-field-label">Schedule*</div>
                  <div className="gm-summary-field-input">{item?.schedule || '-'}</div>
              </div>
            </div>

            <div className="row w-100">
            {item?.schedule === 'Other' ? (
              <>
              <div className="col-md-6 pe-md-2">
                <div className="gm-summary-field-label">Please describe schedule*</div>
                <div className="gm-summary-field-value">{item?.otherSchedule || '-'}</div>
              </div>
              <div className="col-md-6 ps-md-2">
                <div className="gm-summary-field-label">Grading Scale</div>
                <div className="gm-summary-field-input">{item?.CMGradingScale || '-'}</div>
              </div>
              </>
            ): (
              <div className="col-md-6 pe-md-2">
                <div className="gm-summary-field-label">Grading Scale</div>
                <div className="gm-summary-field-input">{item?.CMGradingScale || '-'}</div>
              </div>
            )}
            </div>

            {item?.subjectDetails?.map((subject: any, idx: number) => {
                if (item.schedule === "Yearly" || item.schedule === "Other") {
                  subject.schedule_transcript = ''; // force update prevent error
                }

              return (
                <div key={idx} className="gm-summary-conditional-section">
                  <div className="gm-summary-conditional-title">
                    Course {idx + 1}
                  </div>
                  
                  <div className="gm-summary-checkbox-container">
                     <span
                      style={{marginRight: '12px', fontSize: '18px',
                        color: formatBoolean(subject?.isSummerCourse) ? '#1890ff' : '#d9d9d9',
                        fontWeight: formatBoolean(subject?.isSummerCourse) ? 'bold' : 'normal',
                      }}
                    >
                      {formatBoolean(subject?.isSummerCourse) ? '✓' : '○'}
                    </span>
                    Summer Course
                  </div>
                  
                  <div className="row w-100">
                    <div className="col-md-12">
                      <div className="gm-summary-field-label">Course Name</div>
                      <div className="gm-summary-field-value" style={{ color: subject?.isNew ? 'black' : '#4d88f0' }}>
                          {subject?.courseName || '-'}
                      </div>
                    </div>
                  </div>

                  <div className="row w-100">
                    <div className="col-md-6 pe-md-2">
                      <div className="gm-summary-field-label">A-G Subject Area</div>
                      <div className="gm-summary-field-input">{subject?.AGSubjectArea || '-'}</div>
                    </div>
                    <div className="col-md-6 ps-md-2">
                      <div className="gm-summary-field-label">Subject/Discipline</div>
                      <div className="gm-summary-field-input">{subject?.subject || '-'}</div>
                    </div>
                  </div>

                  {((`${subject?.AGSubjectArea}`.toLowerCase().includes('other than english') ||
                    `${subject?.subject}`.toLowerCase().includes('other than english'))) ? (
                    <>
                    <div className="row w-100">
                      <div className="col-md-6 pe-md-2">
                        <div className="gm-summary-field-label">Language Name</div>
                        <div className="gm-summary-field-input">{subject?.languageName || '-'}</div>
                      </div>
                      <div className="col-md-6 ps-md-2">
                          <div className="gm-summary-field-label">Type of Class *</div>
                          <div className="gm-summary-field-input">{subject?.typeOfClass || '-'}</div>
                      </div>
                    </div>
                    <div className="row w-100">
                      <div className="col-md-6 pe-md-2">
                        <div className="gm-summary-field-label">Is this a weighted course?</div>
                        <div className="gm-summary-field-input">{formatBooleanToYesNo(subject?.isWeightedCourse)}</div>
                      </div>
                    </div>
                    </>
                  ) : (
                    <>
                    <div className="row w-100">
                      <div className="col-md-6 pe-md-2">
                          <div className="gm-summary-field-label">Type of Class *</div>
                          <div className="gm-summary-field-input">{subject?.typeOfClass || '-'}</div>
                      </div>
                      <div className="col-md-6 ps-md-2">
                        <div className="gm-summary-field-label">Is this a weighted course?</div>
                        <div className="gm-summary-field-input">{formatBooleanToYesNo(subject?.isWeightedCourse)}</div>
                      </div>
                    </div>     
                    </>
                  )}


                  {subject?.typeOfClass === 'Dual Enrollment' && (
                    <>
                    <div className="row w-100 py-3">
                      <div className="col-md-12">
                        <CheckboxInput
                          logo="check-label"
                          className='mb-3 check-blue'
                          disabled={true}
                          label="I took this class at a college and/or I received college credit for this class."
                          name={`subjectDetails[${idx}].isTakeClassAtCollege`}
                          values={subject?.isTakeClassAtCollege}
                        />
                      </div>
                    </div>

                    {subject?.isTakeClassAtCollege && (
                      <>
                      <div className="row w-100">
                        <div className="col-md-12">
                        <div className="gm-summary-field-label">Select College *</div>
                          <div className="gm-summary-field-value">
                            {subject?.collegeTookClass || '-'}
                          </div>
                        </div>
                      </div>
                      <div className="row w-100">
                        <div className="col-md-12">
                          <div className="gm-summary-field-label">Grading Scale *</div>
                          <div className="gm-summary-field-input">{subject?.CNGradingScale || '-'}</div>
                        </div>
                      </div>
                     </>
                    )}

                    {subject?.CNGradingScale === 'Numbers' && (
                      <div className="row w-100">
                        <div className="col-md-6 pe-md-2">
                          <div className="gm-summary-field-label">What is the lowest possible number grade at this school?*</div>
                          <div className="gm-summary-field-input">{subject?.lowestGrade || '-'}</div>
                        </div>
                        <div className="col-md-6 ps-md-2">
                          <div className="gm-summary-field-label">What is the highest possible number grade at this school?*</div>
                          <div className="gm-summary-field-input">{subject?.highestGrade || '-'}</div>
                        </div>
                      </div>
                    )}
                    {subject?.CNGradingScale === 'Other' && (
                      <div className="row w-100">
                        <div className="col-md-6 pe-md-2">
                          <div className="gm-summary-field-label">Other Grading Scale *</div>
                          <div className="gm-summary-field-input">{subject?.otherGradeScale || '-'}</div>
                        </div>
                      </div>              
                    )}
                    </>
                  )}

                {(item?.schedule === 'Semester' ||
                  item?.schedule === 'Trimester' ||
                  item?.schedule === 'Quarters') && (
                  <>
                  <div className="row w-100">
                    <div className="col-md-12">
                    <SemesterOption item={item} subject={subject} index={idx} />
                    </div>
                  </div> 
                  <div className="row w-100">
                    <div className="col-md-12">
                      <div className="gm-summary-field-label">
                          How are the grades for this class reported on your transcript?
                        </div>
                        <div className="gm-summary-field-input">{subject?.schedule_transcript || '-'}</div>
                    </div>
                  </div>
                  </>
                )}

                  {item?.CMGradingScale !== 'Other' && subject?.schedule_transcript !== 'One final Grade' && subject?.schedule_transcript && (
                    <>
                    {(semesterOption ?? []).map((opt:any, k:number) => {
                      if (subject?.schedule_transcript === 'One final Grade') return null;
                      if (k === 0 && !subject?.isFirstSemester) return null;
                      if (k === 1 && !subject?.isSecondSemester) return null;
                      if (k === 2 && !subject?.isThirdSemester) return null;
                      if (k === 3 && !subject?.isFourthSemester) return null;
                      let _grade = _getGrade(subject, k);
                      let _credit = _getCredit(subject, k);
                      if (k < _countGrades(item)) {
                      return (
                        <div className="row w-100" key={`grade_credit_${k}`}>
                          <div className="col-md-6 pe-md-2">
                            <div className="gm-summary-field-label">{`${item.schedule} ${k + 1} Grade *`}</div>
                            <div className="gm-summary-field-input">{_grade || '-'}</div>
                          </div>
                          <div className="col-md-6 ps-md-2">
                            <div className="gm-summary-field-label">{`${item.schedule} ${k + 1} Credits *`}</div>
                            <div className="gm-summary-field-input">{_credit || '-'}</div>
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                    </>
                  )}

                  {subject?.schedule_transcript !== 'One grade per term' && (               
                    <div className="row w-100">
                      <div className="col-md-6 pe-md-2">
                        <div className="gm-summary-field-label">Final Grade *</div>
                        <div className="gm-summary-field-input">
                          {subject?.finalGrade || '-'}
                        </div>
                      </div>
                      <div className="col-md-6 ps-md-2">
                        <div className="gm-summary-field-label">Final Credit *</div>
                        <div className="gm-summary-field-input">
                          {subject?.finalCredits || '-'}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className="gm-summary-checkbox-container">
                    <span style={{
                      marginRight: '12px',
                      fontSize: '18px',
                      color: formatBoolean(sub?.checkedNA) ? '#1890ff' : '#d9d9d9',
                      fontWeight: formatBoolean(sub?.checkedNA) ? 'bold' : 'normal',
                    }}>
                      {formatBoolean(sub?.checkedNA) ? '✓' : '○'}
                    </span>
                    N/A
                  </div> */}
                </div>
              );
            })}

          </div>
        )
      }    
    )}
    </>
  );
};

export default CourseGrade9Summary;
